module.exports = __webpack_public_path__ + "img/startupvaley.738c22a6.png";